import axios from 'axios';
import { getApiBaseUrl } from './apiClient';

/**
 * The variant's LIVE barcodes from Shopify (APP-06), for seeding the Products
 * card barcode editor: the cached list misses extras added in Shopify admin
 * since the nightly refresh. null when the row can't be read (no store or
 * variant id) or the read fails; the editor then keeps the cached list and
 * the server still merges the edit onto the live set.
 */
export async function fetchLiveVariantBarcodes(product) {
  const variantId = String(product?.variantId || product?.variantIdLegacy || '').split('/').pop();
  if (!product?.store || !/^\d+$/.test(variantId)) return null;
  try {
    const response = await axios.get(`${getApiBaseUrl()}/api/products/variant-barcodes`, {
      params: { store: product.store, variantId },
      timeout: 8000
    });
    return Array.isArray(response.data?.barcodes) ? response.data.barcodes : null;
  } catch (_) {
    return null;
  }
}
